import { render, staticRenderFns } from "./ProductTarifFiles.vue?vue&type=template&id=04a7da8e&"
import script from "./ProductTarifFiles.vue?vue&type=script&lang=js&"
export * from "./ProductTarifFiles.vue?vue&type=script&lang=js&"
import style0 from "./ProductTarifFiles.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProductTarifFiles.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports